import { PatientHistoryType } from 'src/graphql.generated'
import { PatientHistoryEntry } from 'src/legacy/components/ParticipantRecords/ParticipantHistory/types'
import * as localStorageWithTTL from 'src/legacy/lib/localStorageWithTTL'
import { DEFAULT_INTAKE_NOTE_TTL_IN_HOURS, PatientHistoryFormType } from 'src/participantHistory/constants'

const getFormID = (uid: string, formType: PatientHistoryFormType) => `PatientHistoryForm-${uid}-${formType}`

const intakeNoteFormTypes: PatientHistoryFormType[] = [
  PatientHistoryType.IntakeNote,
  PatientHistoryType.IntakeNotePsychiatry,
]

export const saveFormToLocalStorage = (uid: string, formType: PatientHistoryFormType, values: PatientHistoryEntry) => {
  const formID = getFormID(uid, formType)
  const TTL_IN_HOURS = intakeNoteFormTypes.includes(formType) ? DEFAULT_INTAKE_NOTE_TTL_IN_HOURS : undefined
  localStorageWithTTL.setItem(formID, values, TTL_IN_HOURS)
}

export const getFormFromLocalStorage = (uid: string, formType: PatientHistoryFormType) =>
  localStorageWithTTL.getItem(getFormID(uid, formType))

export const clearFormFromLocalStorage = (uid: string, formType: string) => {
  localStorageWithTTL.clearItem(getFormID(uid, formType as PatientHistoryFormType))
}
